/**
 * 5×5 RFM grid (top row first). Each digit is a region id (1–11).
 *
 *  9  2  2  2  1
 *  8  2  2  2  2
 *  8  6  7  3  3
 * 11 10  7  3  3
 * 11 11  7  5  4
 */
export const RFM_GRID_ROWS = 5;
export const RFM_GRID_COLS = 5;

export const RFM_GRID_CELLS: number[][] = [
  [9, 2, 2, 2, 1],
  [8, 2, 2, 2, 2],
  [8, 6, 7, 3, 3],
  [11, 10, 7, 3, 3],
  [11, 11, 7, 5, 4],
];

export type RfmGroupId =
  | 'champions'
  | 'loyal'
  | 'potential'
  | 'new'
  | 'promising'
  | 'needAttention'
  | 'aboutToSleep'
  | 'at-risk'
  | 'cannot-lose'
  | 'hibernating'
  | 'lost';

export const RFM_REGION_TO_GROUP_ID: Record<number, RfmGroupId> = {
  1: 'champions',
  2: 'loyal',
  3: 'potential',
  4: 'new',
  5: 'promising',
  6: 'needAttention',
  7: 'aboutToSleep',
  8: 'at-risk',
  9: 'cannot-lose',
  10: 'hibernating',
  11: 'lost',
};

function computeRegionAnchors(): Record<number, { row: number; col: number }> {
  const anchors: Record<number, { row: number; col: number }> = {};

  for (let row = 0; row < RFM_GRID_ROWS; row++) {
    for (let col = 0; col < RFM_GRID_COLS; col++) {
      const regionId = RFM_GRID_CELLS[row][col];
      if (anchors[regionId] === undefined) {
        anchors[regionId] = { row, col };
      }
    }
  }

  return anchors;
}

export const RFM_REGION_ANCHORS = computeRegionAnchors();

export function getRegionId(row: number, col: number): number {
  return RFM_GRID_CELLS[row][col];
}

export function regionHasNeighbor(
  row: number,
  col: number,
  dRow: number,
  dCol: number,
  regionId: number
): boolean {
  const neighborRow = row + dRow;
  const neighborCol = col + dCol;

  if (
    neighborRow < 0 ||
    neighborRow >= RFM_GRID_ROWS ||
    neighborCol < 0 ||
    neighborCol >= RFM_GRID_COLS
  ) {
    return false;
  }

  return RFM_GRID_CELLS[neighborRow][neighborCol] === regionId;
}
